import React, { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { t } from "../lib/i18n";
import { api, fmt } from "../lib/api";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";

export default function Cashier() {
  const { lang, user, currency } = useApp();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(null);

  useEffect(() => { api.get("/payments/packages").then(r=>setPackages(r.data)).catch(()=>{}); }, []);

  const buy = async (pkgId) => {
    setLoading(pkgId);
    try {
      const r = await api.post("/payments/checkout", { package_id: pkgId, origin_url: window.location.origin });
      window.location.href = r.data.url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error");
      setLoading(null);
    }
  };

  const filtered = packages.filter(p => p.balance_currency === currency);

  return (
    <div className="max-w-[1300px] mx-auto px-6 lg:px-10 py-10">
      <h1 className="font-serif text-4xl gold-text mb-2">{t(lang,"cashier.title")}</h1>
      <p className="text-white/50 mb-4">{t(lang,"cashier.select_pkg")}</p>
      <div className="bg-[#1a0a0a] border border-[#a40606]/50 rounded-md p-4 mb-6 text-sm">
        <div className="text-[#ffb8b8] flex items-start gap-2">
          <span>⚠️</span>
          <div>
            <strong className="text-white">Play Money vásárlás</strong> — a megvásárolt {currency === "HUF" ? "Gold Coins (GC)" : "Premium Coins (PC)"} csak ebben a játékban használható, <strong>készpénzre nem váltható</strong>. Ez nem szerencsejáték, hanem szociális szórakoztató szolgáltatás. By proceeding you confirm you are 18+.
          </div>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        {filtered.map(p=>(
          <div key={p.id} className="lux-card p-6 text-center">
            <div className="text-xs uppercase tracking-widest text-[#d4af37] mb-3">{p.id.split("_")[1]}</div>
            <div className="text-xs text-white/40 mb-1">Pay</div>
            <div className="font-serif text-2xl mb-3">{p.currency === "huf" ? `${p.amount.toLocaleString("hu-HU")} Ft` : `€${p.amount.toFixed(2)}`}</div>
            <div className="text-xs text-white/40">Get</div>
            <div className="font-serif text-3xl gold-text mb-4">{p.credits.toLocaleString()} {p.balance_currency === "HUF" ? "GC" : "PC"}</div>
            <button data-testid={`buy-${p.id}`} onClick={()=>buy(p.id)} disabled={loading===p.id} className="btn-gold w-full py-3 rounded-md text-sm">
              {loading===p.id?"…":t(lang,"cashier.buy")}
            </button>
          </div>
        ))}
      </div>

      <div className="lux-card p-6">
        <div className="flex items-center gap-3 mb-2"><CreditCard className="text-[#d4af37]"/><h2 className="font-serif text-2xl">Payment methods</h2></div>
        <p className="text-sm text-white/50">Stripe Checkout secure flow. Card · Apple Pay · Google Pay · Klarna (when available). Test mode active — use card 4242 4242 4242 4242.</p>
      </div>
    </div>
  );
}
